module.exports = __webpack_public_path__ + "img/empty-cms.518ab35f.svg";